// Taxonomy matching the SkillCity mobile app: two main audiences, each with subcategories.

export const AUDIENCES = {
  paidia: {
    slug: "paidia",
    title: "Παιδιά",
    title_en: "Kids",
    theme: "blue",
    image: "/brand/home_paidia.jpg",
    caption: "Δραστηριότητες για παιδιά και νέους",
  },
  enilikes: {
    slug: "enilikes",
    title: "Ενήλικες",
    title_en: "Adults",
    theme: "green",
    image: "/brand/home_enilikes.jpg",
    caption: "Δραστηριότητες για ενήλικες",
  },
};

export const SUBCATEGORIES = {
  athlitikoi: { slug: "athlitikoi", title: "Αθλητικοί Σύλλογοι & Σωματεία", title_en: "Sports Clubs & Associations", image: "/cats/athlitikoi_v3.jpg" },
  amea: { slug: "amea", title: "ΑμεΑ Άθληση & Δραστηριότητες", title_en: "Disability Sports & Activities", image: "/cats/amea_v3.jpg" },
  kentra_meletis: { slug: "kentra_meletis", title: "Κέντρα Μελέτης", title_en: "Study Centers", image: "/cats/kentra_meletis_v2.jpg" },
  eikastikes: { slug: "eikastikes", title: "Εικαστικές Τέχνες", title_en: "Visual Arts", image: "/cats/eikastikes_v2.jpg" },
  kdap: { slug: "kdap", title: "ΚΔΑΠ", title_en: "Children's Creative Centers (KDAP)", image: "/cats/kdap_v3.jpg" },
  xenes_glosses: { slug: "xenes_glosses", title: "Φροντιστήρια Ξένων Γλωσσών", title_en: "Foreign Language Schools", image: "/cats/xenes_glosses_v2.jpg" },
  vrefonipiakoi: { slug: "vrefonipiakoi", title: "Βρεφονηπιακοί Σταθμοί - Ιδιωτικά Νηπιαγωγεία", title_en: "Nurseries & Private Kindergartens", image: "/cats/vrefonipiakoi_v3.jpg" },
  syllogoi_xoreutikon: { slug: "syllogoi_xoreutikon", title: "Σύλλογοι Χορευτικών", title_en: "Dance Groups", image: "/cats/syllogoi_xoreutikon_v2.jpg" },
  stem: { slug: "stem", title: "STEM, Ρομποτική & Επιστήμες", title_en: "STEM, Robotics & Sciences", image: "/cats/stem_v2.jpg" },
  eidikes_therapeies: { slug: "eidikes_therapeies", title: "Κέντρα Ειδικών Θεραπειών", title_en: "Special Therapy Centers", image: "/cats/eidikes_therapeies_v4.jpg" },
  robotiki: { slug: "robotiki", title: "Ρομποτική", title_en: "Robotics", image: "/cats/stem_v2.jpg" },
  sxoles_mousikis: { slug: "sxoles_mousikis", title: "Σχολές Μουσικής", title_en: "Music Schools", image: "/cats/sxoles_mousikis_v2.jpg" },
  sxoles_xorou: { slug: "sxoles_xorou", title: "Σχολές Χορού", title_en: "Dance Schools", image: "/cats/sxoles_xorou_v2.jpg" },
  proskopismos: { slug: "proskopismos", title: "Προσκοπισμός", title_en: "Scouting", image: "/cats/proskopismos_v2.jpg" },
  xoroi_ekdiloseon: { slug: "xoroi_ekdiloseon", title: "Χώροι Εκδηλώσεων - Γενεθλίων", title_en: "Event & Birthday Venues", image: "/cats/xoroi_ekdiloseon_v3.jpg" },
};

// Order shown on each audience page (matches the mobile screenshots)
export const AUDIENCE_SUBCATS = {
  paidia: [
    "athlitikoi", "amea", "kentra_meletis", "eikastikes", "kdap", "xenes_glosses",
    "vrefonipiakoi", "syllogoi_xoreutikon", "stem", "eidikes_therapeies",
    "xoroi_ekdiloseon", "proskopismos", "sxoles_mousikis", "sxoles_xorou",
  ],
  enilikes: [
    "athlitikoi", "amea", "sxoles_xorou", "syllogoi_xoreutikon", "sxoles_mousikis",
    "xenes_glosses", "robotiki", "eikastikes", "xoroi_ekdiloseon",
  ],
};

export const CITIES = ["Βόλος", "Λάρισα", "Τρίκαλα", "Καρδίτσα"];

export const getSubcatsForAudience = (audience) =>
  (AUDIENCE_SUBCATS[audience] || []).map((slug) => SUBCATEGORIES[slug]).filter(Boolean);

// Sub-subcategories (sports) inside "Αθλητικοί Σύλλογοι & Σωματεία" (athlitikoi).
export const SPORTS = {
  podosfairo: { slug: "podosfairo", title: "Ποδόσφαιρο", title_en: "Football", image: "/sports/podosfairo_v3.jpg" },
  klasikos: { slug: "klasikos", title: "Κλασσικός Αθλητισμός", title_en: "Track & Field", image: "/sports/klasikos_v3.jpg" },
  basket: { slug: "basket", title: "Μπάσκετ", title_en: "Basketball", image: "/sports/basket_v2.jpg" },
  kolymvisi: { slug: "kolymvisi", title: "Κολύμβηση / Καταδύσεις", title_en: "Swimming / Diving", image: "/sports/kolymvisi_v3.jpg" },
  gymnastiria: { slug: "gymnastiria", title: "Γυμναστήρια / Πιλάτες", title_en: "Gyms / Pilates", image: "/sports/gymnastiria_v3.jpg" },
  ydatosfairisi: { slug: "ydatosfairisi", title: "Υδατοσφαίριση", title_en: "Water Polo", image: "/sports/ydatosfairisi_v3.jpg" },
  tenis: { slug: "tenis", title: "Τένις", title_en: "Tennis", image: "/sports/tenis_v3.jpg" },
  rythmiki: { slug: "rythmiki", title: "Ρυθμική / Ενόργανη", title_en: "Rhythmic / Artistic Gymnastics", image: "/sports/rythmiki_v3.jpg" },
  volei: { slug: "volei", title: "Βόλεϊ", title_en: "Volleyball", image: "/sports/volei_v3.jpg" },
  tzoundo: { slug: "tzoundo", title: "Τζούντο", title_en: "Judo", image: "/sports/tzoundo_v3.jpg" },
  kopilasia: { slug: "kopilasia", title: "Κωπηλασία", title_en: "Rowing", image: "/sports/kopilasia_v3.jpg" },
  pali: { slug: "pali", title: "Πάλη", title_en: "Wrestling", image: "/sports/pali_v3.jpg" },
  podilasia: { slug: "podilasia", title: "Ποδηλασία", title_en: "Cycling", image: "/sports/podilasia_v3.jpg" },
  skaki: { slug: "skaki", title: "Σκάκι", title_en: "Chess", image: "/sports/skaki_v3.jpg" },
  epitr_antisfairisi: { slug: "epitr_antisfairisi", title: "Επιτρ. Αντισφαίριση", title_en: "Table Tennis", image: "/sports/epitr_antisfairisi_v2.jpg" },
  maxitika: { slug: "maxitika", title: "Μαχητικά Αθλήματα", title_en: "Martial Arts", image: "/sports/maxitika_v2.jpg" },
  drastiriotites_fysi: { slug: "drastiriotites_fysi", title: "Δραστηριότητες στη φύση", title_en: "Outdoor Activities", image: "/sports/drastiriotites_fysi_v3.jpg" },
  motosikletismos: { slug: "motosikletismos", title: "Μοτοσικλετισμός", title_en: "Motorcycling", image: "/sports/motosikletismos_v3.jpg" },
  ippasia: { slug: "ippasia", title: "Ιππασία", title_en: "Horse Riding", image: "/sports/ippasia_v2.jpg" },
};

export const SPORTS_ORDER = {
  paidia: ["podosfairo", "klasikos", "basket", "kolymvisi", "ydatosfairisi", "tenis", "rythmiki", "volei",
           "tzoundo", "kopilasia", "pali", "podilasia", "skaki", "epitr_antisfairisi", "maxitika",
           "drastiriotites_fysi", "motosikletismos", "ippasia"],
  enilikes: ["podosfairo", "klasikos", "basket", "kolymvisi", "gymnastiria", "ydatosfairisi", "tenis", "rythmiki",
             "volei", "tzoundo", "kopilasia", "pali", "podilasia", "skaki", "epitr_antisfairisi", "maxitika",
             "drastiriotites_fysi", "motosikletismos", "ippasia"],
};

export const getSportsForAudience = (audience) =>
  (SPORTS_ORDER[audience] || []).map((slug) => SPORTS[slug]).filter(Boolean);
